import * as signalR from "@microsoft/signalr";
import { DOUBLE_MATCH } from "../navigation/Constants";
import { default as apiConfing } from "../config.json";
import { setUnreadMessageCount } from "../redux/member";
import { addConversation } from './../redux/carpet';
import { getMyMemberDetails } from './memberService';
import { setUserData } from '../redux/member';
const apiUrl = apiConfing.IS_DEVELOPMENT ? apiConfing.SIGNALR_DEVELOPMENT : apiConfing.SIGNALR_PRODUCTION;

export const startSignalRConnection = (memberCode, history, dispatch) => {

   var url = apiUrl;

   const hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(url)
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

   hubConnection.serverTimeoutInMilliseconds = 60000;

   // Starts the SignalR connection
   hubConnection.start().then((a) => {
      if (hubConnection.connectionId) {
         hubConnection.invoke("connectionOpen", hubConnection.connectionId, parseInt(memberCode));




         hubConnection.on('ReceivedDoubleMatch', (message) => {
            setTimeout(() => {
               history.replace({
                  pathname: DOUBLE_MATCH,
                  state: {
                     data: message,
                     prevLocation: history.location.pathname + history.location.search
                  },
               })
            }, 500)
         });


         // hubConnection.on('getChatNotification', async (numOfUnreadMessages) => {
         //      const location = window.location.href;
         //      if (location.includes("messagesScreen")) {
         //           const { data } = await GetMemberCarpetChat(memberCode);
         //           dispatch(setMessagesScreenMessagesAction(data.results))
         //      }
         //      dispatch(setNumberOfUnreadMessages(numOfUnreadMessages))
         // });
         hubConnection.on('getNewMessageNotification', (numOfUnreadMessages) => {
            dispatch(setUnreadMessageCount(numOfUnreadMessages));
         });

         //make sure i send the code of the member i update the data
         hubConnection.on('UpdateMemberData', async (memberCodeFromApi) => {
            const { data } = await getMyMemberDetails(memberCodeFromApi);
            dispatch(setUserData(data));
         });

         hubConnection.on('getUpdateMessageNotification', (message) => {
            const location = window.location.href + window.location.search;
            if (location.includes("converstaion")) {
               dispatch(addConversation(message))

            }
         });

      }
   }).catch((e) => console.log(e));

   hubConnection.onclose(async () => {
      hubConnection.invoke("connectionClosed", parseInt(memberCode));
      hubConnection.stop();
   });

   window.onbeforeunload = function (e) {
      //This is called when we close the page
      hubConnection.invoke("connectionClosed", parseInt(memberCode));
      hubConnection.stop();
   };

   // if hubConnection.connectionId has value activete function to add/remove user from online user table depandes on the app state

   // window.closeSocketConnection = () => {
   //    hubConnection.invoke("connectionClosed", parseInt(memberCode));
   //    hubConnection.stop();
   // }

   // window.openSocketConnection = () => {
   //    if (hubConnection.connectionId) {
   //       hubConnection.invoke("connectionOpen", hubConnection.connectionId, parseInt(memberCode));
   //    }
   // }


   hubConnection.onreconnecting(() => {
      console.log("start reconnecting");
   });

   hubConnection.onreconnected(() => {
      if (hubConnection.connectionId) {
         console.log("finish reconnecting", hubConnection.connectionId);
         hubConnection.invoke("reconnected", hubConnection.connectionId, parseInt(memberCode));
      }
   });

   return hubConnection;
}
